import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  files: [],
};

export const fileSlice = createSlice({
  name: "file",
  initialState,
  reducers: {
    setFilesList: (state, { payload }) => {
      state.files = payload;
    },
    fileRemove: (state, { payload }) => {
      state.files = state.files.filter((file) => file !== payload);
    },
  },
});
